import React from 'react';
// Ui
import Modal from 'ui3/Modal/Modal';
import Button from 'ui3/Button/Button';
// Styles
import styles from './SocialAuthorizationDialog.module.scss';

type SocialAuthorizationDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onAuthorize: () => void;
  socialPlatformName: string;
  loading?: boolean;
};

const SocialAuthorizationDialog = ({
  isOpen,
  onClose,
  onAuthorize,
  socialPlatformName,
  loading = false,
}: SocialAuthorizationDialogProps) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      closeOnOverlayClick={!loading}
      title={`Link ${socialPlatformName}?`}
      subTitle={`Please authorize this app to connect to your ${socialPlatformName} account.`}
      size="small"
    >
      <div className={styles.actions}>
        <Button variant="success" onClick={onAuthorize} block loading={loading}>
          Authorize
        </Button>
        <Button variant="secondary" onClick={onClose} block disabled={loading}>
          Cancel
        </Button>
      </div>
    </Modal>
  );
};

export default SocialAuthorizationDialog;
